import { Flex } from '@chakra-ui/react'
import { forwardRef } from 'react'

export enum StepBadgeColor {
  RED = 'RED',
  ORANGE = 'ORANGE',
  GREEN = 'GREEN',
}

export const StepBadge = forwardRef(
  ({ content, color }: { content: React.ReactElement | string; color?: StepBadgeColor }, ref: any) => {
    let mapColor = (color?: StepBadgeColor) => {
      switch (color) {
        case StepBadgeColor.RED:
          return '#FF3288'
        case StepBadgeColor.ORANGE:
          return '#FFB800'
        case StepBadgeColor.GREEN:
          return '#4EFF60'
        default:
          return 'rgba(255, 255, 255, 0.24)'
      }
    }
    return (
      <Flex
        ref={ref}
        flexShrink={0}
        gap={2.5}
        px={2}
        py={1.5}
        bg={'rgba(255, 255, 255, 0.01)'}
        boxShadow={`0px -12px 20px -14px ${mapColor(color)} inset;`}
        rounded={'xl'}
        alignItems={'center'}
        fontWeight={700}
        fontSize={'xs'}
        cursor={'default'}
        userSelect={'none'}
      >
        {content}
      </Flex>
    )
  }
)
